<template>
  <v-app id="inspire" class="hello" style="background-color:white;min-width:320px;">
    <v-container>
      <v-row justify="end">
        <v-col cols="auto">
          <user_info_edit_dialog ref="userInfoEditDialog" @completeEdit="onCompleteEdit"></user_info_edit_dialog>
          <v-btn
            style="text-align:right"
            color="primary"
            outlined
            dark
            @click="openEditDialog"
          >
            <v-icon dark small></v-icon>
            登録情報の編集
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            style="text-align:right"
            color="primary"
            @click="logOut"
            outlined
            dark
          >
            ログアウト
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <p class="Title">
            <br/>
            My Page
            <br/>
            マイページ
          </p>
        </v-col>

        <v-col cols="12">
          <div class="subTitle"><span>ご登録情報</span></div>
        </v-col>

        <v-col cols="12" class="text-center">
          <p><img src="../assets/UserImage.png" class="user_image"></p>
        </v-col>
        <v-col cols="12" class="text-center">
          <p>
            <span class="userName">{{this.userInfo.lastName}} {{this.userInfo.firstName}}</span>
            <br/>
            <span class="userInfo">{{this.userInfo.username}}</span>
            <br/><br/>
            <span class="userCompany">{{this.userInfo.companyName}}</span>
            <br/>
            <span class="userInfo">{{this.userInfo.address}}</span>
          </p>
        </v-col>

        <v-col cols="12">
          <table class="messageBill">
            <tr>
              <td>
                <v-icon class="mr-3 blue-grey--text darken-4">fa-exclamation-circle</v-icon>
              </td>
              <td>
                <div class="blue-grey--text darken-4">
                  申し込みはまだ完了しておりません。<br/>
                  請求書をご確認のうえ、期日までにお振り込みをお願いいたします。
                </div>
              </td>
            </tr>
          </table>
        </v-col>

        <v-col cols="12" md="8" xl="6">
          <p class="text-center">
            <v-btn
              color="blue-grey"
              class="white--text buttonStyle"
              @click="downloadInvoice"
              rounded
            >
              請求書ダウンロード
            </v-btn>
          </p>
          <visitor_invoice_download_dialog ref="visitorInvoiceDownloadDialog"></visitor_invoice_download_dialog>
        </v-col>

        <!---

        <v-col cols="12">
          <div class="subTitle"><span>請求先情報</span></div>
        </v-col>

        <v-col cols="12">
            <table class="bankAccountInfo ml-3">
              <tr>
                <td>
                  金融機関名
                </td>
                <td>:</td>
                <td>
                  {{this.formatedBankName}}
                </td>
              </tr>
              <tr>
                <td>
                  口座番号
                </td>
                <td>:</td>
                <td>
                  {{this.formatedBankAccountNumber}}
                </td>
              </tr>
              <tr>
                <td>
                  口座名義
                </td>
                <td>:</td>
                <td>
                  {{this.bankTransferEventSettings.bankAccountHolderName}}
                </td>
              </tr>
              <tr>
                <td>
                  支払期限
                </td>
                <td>:</td>
                <td>
                  {{this.formatedPaymentDeadline}}
                </td>
              </tr>
            </table>

            <template v-if="this.bankTransferEventSettings.description">
              <div class="mt-5 ml-3"><span class="text-left" style="white-space: pre-wrap">{{this.bankTransferEventSettings.description}}</span></div>
            </template>
        </v-col>

        --->

        <v-col cols="12" v-if="this.userInfo.ticketId != null">
          <div class="subTitle"><span>参加券情報</span></div>
        </v-col>
        <v-col cols="12" v-if="this.userInfo.ticketId != null">
          <p class="text-left infotext">
            <span style="padding-left: 5px">{{this.userInfo.ticketName}}</span>
            <span v-if="this.userInfo.ticketPrice > 0"> {{this.userInfo.ticketPrice| toPriceLocaleString}}円{{this.userInfo.ticketTaxType|toTaxTypeString}}</span>
          </p>
          <div class="text-left infotext ticketDescription" v-if="this.userInfo.ticketDescription != undefined && this.userInfo.ticketDescription.length > 0">
            <p>
              <span>{{this.userInfo.ticketDescription}}</span>
            </p>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="subTitle"><span>イベント名</span></div>
        </v-col>
        <v-col cols="12">
          <p class="text-left contents">{{this.event_data.eventName}}</p>
        </v-col>

        <template v-if="information">
          <v-col cols="12">
            <div class="subTitle subContentsTitle"><span>イベント概要</span></div>
          </v-col>
          <v-col cols="12">
            <p class="text-left infotext" v-html="information"></p>
          </v-col>
        </template>

        <v-col cols="12">
          <div class="subTitle subContentsTitle"><span>主催者情報</span></div>
        </v-col>
        <v-col cols="12">
          <p class="text-left infotext" v-html="organizerInfo"></p>
        </v-col>


        <v-col cols="12">
          <div class="subTitle subContentsTitle"><span>会期日</span></div>
        </v-col>

        <v-col cols="12">
          <p class="text-left contents">
            {{formatDateWithDayOfWeek(this.event_data.eventDate)}}
            <template v-if="event_data.eventEndDate != null">
              〜 {{formatDateWithDayOfWeek(this.event_data.eventEndDate)}}
            </template>
          </p>
        </v-col>

        <v-col cols="12">
          <div class="subTitle subContentsTitle"><span>会期時間</span></div>
        </v-col>

        <v-col cols="12">
          <p class="text-left contents">{{this.event_data.startTime}}〜{{this.event_data.endTime}}</p>
        </v-col>

        <template v-if="facility.id > 0">
          <v-col cols="12">
            <div class="subTitle subContentsTitle"><span>会場アクセス</span></div>
          </v-col>

          <v-col cols="12">
            <p class="text-left contents">
              {{this.facility.facilityName}}
            </p>
            <p class="text-left contents">
              {{this.event_data.roomDescription}}
            </p>
            <p class="text-left contents thin" style="font-size:120%;">
              {{this.facility.address}}
            </p>
          </v-col>

          <!-- PC時地図 -->
          <v-col cols="12" class="hidden-sm-and-down">
            <v-row justify="start">
              <v-col cols="auto" v-if="mapUrlEnabled">
                <p class="text-md-left">オリジナルマップ</p>
                <p class="text-md-left"><img v-bind:src="facility.mapUrl" width="560" @error="imgError()"></p>
              </v-col>
              <v-col cols="auto" v-if="facility.googleMapUrl !== null">
                <p class="text-md-left">Google Map</p>
                <div class="mapresize">
                  <p class="text-md-left" v-html="facility.googleMapUrl"></p>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- スマホ時地図 -->
          <v-col cols="12" class="hidden-md-and-up">
            <div class="maparea text-center">
              <v-tabs
                centered
                background-color="grey"
                dark
                icons-and-text
              >
                <v-tabs-slider color="white"></v-tabs-slider>
                <template v-if="mapUrlEnabled">
                  <v-tab class="maparea" href="#tab-1" v-if="mapUrlValid">
                    オリジナルマップ
                  </v-tab>
                </template>
                <v-tab class="maparea" href="#tab-2" v-if="facility.googleMapUrl !== null">
                  Google Map
                </v-tab>
                <template v-if="mapUrlEnabled">
                  <v-tab-item
                    :id="`tab-1`"
                    :key="1"
                  >
                    <p class="text-center">
                      <img v-bind:src="facility.mapUrl" width="100%" @error="imgError()">
                    </p>
                  </v-tab-item>
                </template>
                <v-tab-item
                  :id="`tab-2`"
                  :key="2"
                >
                  <p class="text-center" v-html="facility.googleMapUrl"></p>
                </v-tab-item>
              </v-tabs>
            </div>
          </v-col>
        </template>
      </v-row>

      <v-row v-if="cancelEnabled">
        <v-col cols="12" class="text-center">
          <v-btn
            outlined
            color="Grey"
            class="Grey--text buttonStyle"
            @click.native="cancel"
            rounded
          >
            申し込みをキャンセル
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {
  getMe,
  getPayeesBankAccount,
  getEvent,
  cancelEvent,
  getEventId,
  recordMyPageAccess,
  signout
} from "../VisitorAPIUtils";
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import commonStaticMap from "@/mixins/commonStaticMap"
const UserInfoEditDialog = () => import( '@/components/Publish/MyPageUserInfoEditDialog.vue' )
const visitorInvoiceDownloadDialog  = () => import( "@/components/VisitorInvoiceDownloadDialog.vue" )
export default {
  name: 'TentativeReservedVisitor',
  components: {
    'user_info_edit_dialog': UserInfoEditDialog,
    'visitor_invoice_download_dialog': visitorInvoiceDownloadDialog
  },
  mixins: [
    commonStaticMap
  ],
  data() {
    return {
      gtmTool: {},

      eventId: '',
      publishId: '',
      userInfo: {},
      qrUrl: '',
      event_data: {},
      facility: {},

      bankTransferEventSettings :{
        bankType: '',
        bankName: '',
        branchName: '',
        bankAccountType: '',
        bankAccountNumber: '',
        bankAccountHolderName: '',
        paymentDeadline: '',
        description: '',
      },

      mapUrlValid: true,
    }
  },
  computed: {
    information() {
      return (this.event_data.information) ? this.event_data.information.trim() : ''
    },
    organizerInfo() {
      return (this.event_data.organizerInfo) ? this.event_data.organizerInfo.trim() : ''
    },
    cancelEnabled() {
      if(this.event_data.notCancellable) return false

      return (this.userInfo.ticketId === null || this.userInfo.ticketPrice === 0) //undefinedに反応させない
    },
    mapUrlEnabled() {
      return this.isUsedStaticMapOriginalMap(this.facility.usedStaticMapType)
        && (this.facility.mapUrl)
        && this.mapUrlValid
    },
    formatedBankName() {
      return (this.bankTransferEventSettings.bankType == 'JAPAN_POST_BANK') ?
        'ゆうちょ銀行' :
        this.bankTransferEventSettings.bankName
    },
    formatedBankAccountNumber() {
      if(this.bankTransferEventSettings.bankType == 'JAPAN_POST_BANK') {
        return this.bankTransferEventSettings.bankAccountNumber
      } else {
        let bankAccountType;
        switch(this.bankTransferEventSettings.bankAccountType) {
          case 'SAVING_ACCOUNT' :
            bankAccountType = '普 ) '
            break
          case 'CHECKING_ACCOUNT' :
            bankAccountType = '当 ) '
            break
          default :
            bankAccountType = ''
        }

        return bankAccountType + this.bankTransferEventSettings.bankAccountNumber
      }
    },
    formatedPaymentDeadline() {
      return this.formatDateWithDayOfWeek(this.bankTransferEventSettings.paymentDeadline)
    },
  },
  filters: {
    toPriceLocaleString : function (value){
      if(!value){
        return 0;
      }
      return value.toLocaleString('ja-JP', {"style": "currency", "currency": "JPY"});
    },
    toTaxTypeString : function (value) {
      return value == "CONSUMPTION_TAX" ? "(税込)" : "(不課税)"
    },
    toDurationString : function (duration) {
      let ret = '再生時間 : '
      if(duration.match(/[1-9]/)) {
        return ret += duration
      } else {
        return ret += '--:--'
      }
    }

  },
  methods: {
    formatDateWithDayOfWeek(date) {
      return dayjs(date).format('YYYY-M-D(ddd)')
    },
    openEditDialog() {
      this.$refs.userInfoEditDialog.open(
        this.eventId,
        this.userInfo,
        this.event_data
      )
    },
    downloadInvoice() {
      this.$refs.visitorInvoiceDownloadDialog.open(this.eventId)
    },
    onCompleteEdit() {
      let headers = {accountType: 'visitor', eventId: this.eventId}
      this.load(headers)
    },
    cancel() {
      if (confirm("イベント申し込みをキャンセルしてもよろしいでしょうか？")) {
        cancelEvent({eventId: this.eventId}).then(res => {
          alert("イベント申し込みのキャンセルが完了しました")
          this.$router.push("/" + this.publishId)
        }).catch(err => {
          switch (err.response.status) {
            case 410:
              alert("キャンセル可能期間を過ぎています。主催者へお問い合わせください。");
              break;
            default:
              alert("イベント申し込みのキャンセルに失敗しました")
              break;
          }
        })
      }
    },
    logOut() {
      signout().then(res => {
        this.$router.push("/" + this.publishId)
      })
    },
    load(headers) {
      getMe({headers: headers})
        .then(res => {
          this.gtmTool.sendBasicTimings()

          this.userInfo = {...res.data}
        }).catch(err => {
          alert("登録情報の取得に失敗しました")
          this.$router.push("/" + this.publishId)
        })
    },
    imgError() {
      this.mapUrlValid = false
    },
    recordMyPageAccess() {
      recordMyPageAccess({
        publishId: this.publishId
      }).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
  },
  beforeCreate() {
    dayjs.locale('ja')
  },
  mounted() {
    this.publishId = this.$route.params.publishId

    this.gtmTool = this.getGtmTool()
    this.gtmTool.setEventPublishId(this.publishId)
    this.gtmTool.setMounted()

    getEventId({
      publishId: this.publishId
    }).then(resEventId => {
      this.eventId = resEventId.data

      let headers = {accountType: 'visitor',eventId:this.eventId}
      this.load(headers)
      getEvent({publishId: this.publishId}).then(res => {
        this.event_data = {...res.data};
        this.facility = this.event_data.facility
        this.event_data.startTime = this.event_data.startTime.substring(0, 5).replace(/-/g, ":");
        this.event_data.endTime = this.event_data.endTime.substring(0, 5).replace(/-/g, ":");

        getPayeesBankAccount({
          publishId: this.publishId
        }).then(res => {
          this.bankTransferEventSettings.bankType = res.data.bankType
          this.bankTransferEventSettings.bankName = res.data.bankName
          this.bankTransferEventSettings.branchName = res.data.branchName
          this.bankTransferEventSettings.bankAccountType = res.data.bankAccountType
          this.bankTransferEventSettings.bankAccountNumber = res.data.bankAccountNumber
          this.bankTransferEventSettings.bankAccountHolderName = res.data.bankAccountHolderName
          this.bankTransferEventSettings.paymentDeadline = res.data.paymentDeadline
          this.bankTransferEventSettings.description = res.data.description

          this.recordMyPageAccess()
        }).catch(err => {
          alert("口座情報の取得に失敗しました")
          this.$router.push("/" + this.publishId)
        })

      }).catch(err => {
        console.log('err', err)
        this.$router.push("/" + this.publishId)
      })
    }).catch(err => {
      this.$router.push("/" + this.publishId)
    })
  }
}
</script>

<style scoped>
#inspire{
  min-width:320px;
  color: #555555;
}
.Title{
  font-size:150%;
}
.subTitle{
  position: relative;
  text-align: left;
  font-size:130%;
  font-weight:bold;
  color:#787878;
}
.subTitle:before {
  border-top: 1px solid;
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
}
.subTitle span {
  background-color: white;
  display: inline-block;
  padding: 0 0.5em;
  position: relative;
}
.subContentsTitle{
  font-size:100%;
}
.contents{
  font-size:150%;
  color:#787878;
  font-weight:bold;
  text-indent:5px;
}
.contents.thin{
  color:#555555;
  font-weight:normal;
}
.infotext{
  font-size:120%;
  color:#555555;
  padding-left: 5px;
}
.maparea{
  font-size:110%;
}
.mapresize{
  width: 560px;
  height: 315px;
  display: block;
  overflow: hidden;
  position: relative;
}
.buttonStyle{
  width:50%;
}
.userName{
  font-size:180%;
}
.userInfo{
  font-size:110%;
}
.userCompany{
  font-size:140%;
}
.user_image{
  max-width:80px;
}
.modalHeader{
  background-color: #49abdc;
  color: white;
  height: 70px;
  font-size:160%;
  font-weight:bold;
  filter:alpha(opacity=100);
  -moz-opacity: 1;
  opacity: 1;
}

.ticketDescription {
  padding-left: 30px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ticketDescription p {
  font-size: 100%;
}

.messageBill{
  margin-left: auto;
  margin-right: auto;
  border: double 5px #607d8b;
}
.messageBill > tr > td {
  vertical-align: top;
  font-weight: bold;
}

.bankAccountInfo {
}
.bankAccountInfo > tr > :nth-child(1) {
  text-align: left;
}
.bankAccountInfo > tr > :nth-child(2) {
  text-align: center;
}
.bankAccountInfo > tr > :nth-child(3) {
  text-align: left;
}
</style>
